import { render, staticRenderFns } from "./capabilities.vue?vue&type=template&id=7eb8c2dd&scoped=true&"
import script from "./capabilities.vue?vue&type=script&lang=js&"
export * from "./capabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb8c2dd",
  null
  
)

export default component.exports